import { ref, reactive } from 'vue'
import type { Prospect, Activity, ProspectStage } from '@/types'

export interface CRMState {
  prospects: Prospect[]
  activities: Activity[]
  selectedProspect: Prospect | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    stage: ProspectStage | ''
    assignedTo: string
    source: string
  }
}

export const getInitialFilters = () => ({
  search: '',
  stage: '' as ProspectStage | '',
  assignedTo: '',
  source: '',
})

export const createState = (): CRMState => {
  const prospects = ref<Prospect[]>([])
  const activities = ref<Activity[]>([])
  const selectedProspect = ref<Prospect | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)
  const filters = reactive(getInitialFilters())

  return reactive({
    prospects,
    activities,
    selectedProspect,
    isLoading,
    error,
    filters,
  }) as unknown as CRMState
}

export const resetState = (state: CRMState): void => {
  state.prospects = []
  state.activities = []
  state.selectedProspect = null
  state.isLoading = false
  state.error = null
  Object.assign(state.filters, getInitialFilters())
}
